export default "__VITE_ASSET__61ac76e1__"